// src/components/Footer.jsx
import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faLinkedin, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons'; 
import { faEarthAsia, faPhone, faAt } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <span className="footer-brand">Ganesh Amgain</span>
          <div className="footer-links">
            <p><FontAwesomeIcon icon={faPhone} style={{color: "#26a69a", fontSize: "20px"}} />   +977  <a href="tel:9849081162">984-9081162</a>,  <a href="tel:9801172544">980-1172544</a></p>
            <p><FontAwesomeIcon icon={faAt} style={{color: "#26a69a", fontSize: "20px"}} />   <a href="mailto:ganeshamgain@gmail.com">ganeshamgain@gmail.com</a></p>
          </div>
        </div>

        <div className="footer-middle">
          <span className="social-name">Personal Handles:</span>
          <div className="social-icons">
            <a href="https://www.facebook.com/ganesh.amgain.5" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.instagram.com/ganeshamgain/" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.linkedin.com/in/ganesh-amgain-642251287/" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.youtube.com/@alignwithganesh" aria-label="YouTube">
              <FontAwesomeIcon icon={faYoutube} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
          </div>
        </div>

        <div className="footer-right">
          <span className="social-name">Professional Handles</span>
          <div className="social-icons">
            <span className="footer-social-label">Follow Nirvana PSCC:</span>
            <a href="https://nirvanapscc.com/" aria-label="Website">
              <FontAwesomeIcon icon={faEarthAsia} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.facebook.com/nirvanapscc" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.instagram.com/nirvanapscc/" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.tiktok.com/@nirvanapscc" aria-label="Tiktok">
              <FontAwesomeIcon icon={faTiktok} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
          
          </div>
          
        
          <div className="social-icons">
            <span className="footer-social-label">Follow Nirvana Yogalaya:</span>
            <a href="https://nirvanayogalaya.org/" aria-label="Website">
              <FontAwesomeIcon icon={faEarthAsia} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.facebook.com/nirvanayogalaya" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.instagram.com/nirvana_yogalaya/" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
            <a href="https://www.tiktok.com/@nirvanayogalaya" aria-label="Tiktok">
              <FontAwesomeIcon icon={faTiktok} style={{color: "#26a69a", fontSize: "20px"}} />
            </a>
        
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} Ganesh Amgain. All rights reserved.</p>
          <p>
            Developed and Managed by{" "}
            <a
              href="https://www.facebook.com/people/Matrix-Spark-Agency/61581482506319/?rdid=vCx6CqLmrYBHChee&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BFKinDwZS%2F"
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                textDecoration: "none",
                color: "inherit"
              }}
            >
              Matrix Spark Agency
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
